var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.967,
    height: 14.975,
    viewBox: "0 0 19.967 14.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-line",
    transform: "translate(-10.66 -31.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M29.379,31.98H11.908a1.248,1.248,0,0,0-1.248,1.248V45.707a1.248,1.248,0,0,0,1.248,1.248H29.379a1.248,1.248,0,0,0,1.248-1.248V33.228A1.248,1.248,0,0,0,29.379,31.98Zm-.961,13.727H12.944l4.368-4.517-.9-.867-4.5,4.661V34.176l7.756,7.718a1.248,1.248,0,0,0,1.76,0l7.955-7.912V44.9L24.786,40.31l-.88.88ZM12.725,33.228H28.368l-7.824,7.781Z",
    fill: "#9d9d9d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGrey);
export default __webpack_public_path__ + "static/media/email-grey.e136e8b0eada473cfb4bd35818be798f.svg";
export { ForwardRef as ReactComponent };